import { createSelector } from 'reselect';

const selectOpenNetworkProductTypes = (state: any) => state.openNetworkProductTypes;


export const selectOpenNetworkProductTypesCurrentItem = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.current);

export const selectOpenNetworkProductTypesListItems = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectOpenNetworkProductTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpenNetworkProductTypesQueryItems = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.query);

export const selectOpenNetworkProductTypesCreatedItem = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.create);

export const selectOpenNetworkProductTypesUpdatedItem = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.update);

export const selectOpenNetworkProductTypesReadItem = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.read);

export const selectOpenNetworkProductTypesDeletedItem = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.delete);

export const selectOpenNetworkProductTypesSearchedItems = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.search);

export const selectOpenNetworkProductTypesItemsCount = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.count);

export const selectOpenNetworkProductTypesItemsFilter = createSelector([selectOpenNetworkProductTypes], (openNetworkProductTypes) => openNetworkProductTypes.filter);